import React, { Fragment, useContext } from 'react'
import Navbar from '../Navbar'
import Context from '../../context/AppContext'

const Layot = ({ children }) => {
    const { navigation } = useContext(Context)
    return (
        <Fragment>
            {
                navigation ? <Navbar /> : <></>
            }
            <div className="main">{children}</div>
        </Fragment>
    )
}

export default Layot